// extracted by mini-css-extract-plugin
export var button = "_92-0";
export var icon = "_92-1";